
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_4c84z_8bu7b_93",
  "variant-secondary": "awsui_variant-secondary_4c84z_8bu7b_162",
  "variant-primary": "awsui_variant-primary_4c84z_8bu7b_197",
  "variant-info": "awsui_variant-info_4c84z_8bu7b_230",
  "variant-value-large": "awsui_variant-value-large_4c84z_8bu7b_265",
  "variant-top-navigation": "awsui_variant-top-navigation_4c84z_8bu7b_297",
  "variant-recovery": "awsui_variant-recovery_4c84z_8bu7b_330",
  "button": "awsui_button_4c84z_8bu7b_363",
  "color-inverted": "awsui_color-inverted_4c84z_8bu7b_398",
  "font-size-body-s": "awsui_font-size-body-s_4c84z_8bu7b_416",
  "font-size-body-m": "awsui_font-size-body-m_4c84z_8bu7b_423",
  "font-size-heading-xs": "awsui_font-size-heading-xs_4c84z_8bu7b_429",
  "font-size-heading-s": "awsui_font-size-heading-s_4c84z_8bu7b_435",
  "font-size-heading-m": "awsui_font-size-heading-m_4c84z_8bu7b_442",
  "font-size-heading-l": "awsui_font-size-heading-l_4c84z_8bu7b_449",
  "font-size-heading-xl": "awsui_font-size-heading-xl_4c84z_8bu7b_456",
  "font-size-display-l": "awsui_font-size-display-l_4c84z_8bu7b_463",
  "font-size-inherit": "awsui_font-size-inherit_4c84z_8bu7b_470",
  "icon-wrapper": "awsui_icon-wrapper_4c84z_8bu7b_478",
  "icon": "awsui_icon_4c84z_8bu7b_478"
};
  